/* global _ */

(function () {
  'use strict';

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').directive("wsHeatmap", ['ChartUtils', 'wsColors', function (ChartUtils, wsColors) {
    return {
      templateUrl: "modules/app/views/chart-include.html",
      scope: {
        /*
        definition: See wsReportChart definition later on the page.
                    This controller just sets some default values for that.
         */
        definition: "="
      },
      controller: ["$scope", function ($scope) {
        $scope.definition = $.extend(true, {}, {
          currentDuration: null,
          listerControls: {
            alternativePageSize: 0
          }
        }, $scope.definition);
        var chartUpdate = _.bind($scope.definition.updateChartData, $scope.definition),
          chartDefaults = {
            chart: {
              type: 'heatmap'
            },
            series: [{
              borderColor: wsColors.colorBorder,
              borderWidth: 2,
              dataLabels: {
                color: wsColors.wsBlack,
                useHTML: true
              }
            }],
            xAxis: {
              lineWidth: 0,
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              minorTickColor: 0,
              tickLength: 0,
              opposite: true
            },
            yAxis: {
              lineWidth: 0,
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              minorTickColor: 0,
              tickLength: 0,
              title: {
                text: null
              },
              reversed: true
            },
            colorAxis: {
              min: 0,
              minColor: wsColors.colorBorder,
              maxColor: ChartUtils.getSeriesColor($scope.config, 0, wsColors.wsBlueLight)
            },
            legend: {
              enabled: false
            },
            title: {
              text: null
            },
            tooltip: {
              followPointer: true
            },
            plotOptions: {
              series: {
                states: {
                  hover: {
                    enabled: false
                  }
                }
              }
            }
          };
        $scope.definition.updateChartData = function (data, element) {
          data = data || this.data;
          var chart = chartUpdate(data, this.selectedDataOption),
            //If you base it entirely off the number of items in the chart, then you're not accounting
            //for a bit of extra height that accounts for the padding and label. This approximates that.
            heightPadding = 70,
            //targetHeight is the desired height for each cell of the heatmap, it'll be accurate to
            // a couple pixels
            targetHeight = 50,
            //determines what approx yOffset and characters should be based on label length
            maxLines = 4,
            labelInfo = getLabelInfo(chart.xAxis.categories, maxLines),
            yOffset = labelInfo.yOffset * -1;
          this.height = targetHeight * chart.yAxis.categories.length + heightPadding + yOffset;
          this.width = chart.xAxis.categories.length === 1 ? element.width() / 2 : undefined;
          this.chart = $.extend(true, {}, chartDefaults, chart, {
            chart: {
              height: this.height,
              width: this.width
            },
            xAxis: {
              labels: {
                y: labelInfo.yOffset,
                formatter: function formatter() {
                  return ChartUtils.formatCategories(this.value, labelInfo.characters, maxLines, maxLines);
                }
              }
            }
          });
        };
        function getLabelInfo(xAxisCategories, maxLines) {
          //using a gross estimation that about 120 characters can fit across the x axis
          //would be much better to refine this based on current bootstrap column size
          var totalCharacters = 120;
          var maxCategory = _.max(xAxisCategories, function (x) {
            return x.length;
          });
          var columnLength = Math.round(totalCharacters / xAxisCategories.length);
          var numberOfLines = ChartUtils.separateLabelIntoLines(maxCategory, columnLength).length;
          numberOfLines = numberOfLines > 0 ? numberOfLines : 1;
          numberOfLines = numberOfLines > maxLines ? maxLines : numberOfLines;

          //-5 for first line, and -15 for each additional line
          var yOffset = -15 * (numberOfLines - 1) - 5;
          return {
            yOffset: yOffset,
            characters: columnLength
          };
        }
      }]
    };
  }]).directive("wsReportChart", ["wsPaginate", "$uibModal", "ActivityDifficultyThresholds", function (Paginate, $uibModal, DifficultyThresholds) {
    return {
      templateUrl: "modules/app/views/chart-wrapper.html",
      scope: {
        /*
        Definition: {
            cardId: ID of the card we're currently on
             bullet: Object from ViewUtils.makeBullet(),
             data: Required. The raw data used to build the chart (used in updateChartData function).
                (note: if paginated is true, you'll have to supply a "name" property to each object in data for the search bar to work)
             chart: Should be set in updateChartData function (this is highcharts chart definition)
             customCharts: Should be set in updateChartData function. Specification of a Watershed chart to be used (see wsCustomChart),
             title: {
                 text: text of any title to be displayed,
                 emphasized: option for displaying the title (bold),
                 main: option for displaying the title (blue) (only works if emphasized is also true)
             },
             subtitle: any subtitle to be displayed,
             subtitleData: further information about the subtitle,
             currentDuration: Used to drive the view if there are multiple views to be displayed and they're toggleable with a dropdown,
             updateChartData: Required. Takes "data" as a method parameter. (Data value is updated by directive, based on filter/paging) Used to update chart variable or custom chart. function callback every time that the view changes (from the duration or scoreType, typically),
             durations: List of possible options for the view drop down,
             height: 400 (default, change if necessary),
             width: undefined (default, change if necessary),
             currentData: function that will be called to get the current set of viewed data,
             questionId: The object ID of the statement you're currently viewing if you want to dive
              into it with View individual statements,
             isQuestion: If this is false, then you won't see information about the question analysis,
             dataOptions: Drive the pills that are displayed for toggleable views,
             selectedDataOption: What option to initially select from the given dataOptions
             paginated: boolean. if true, then pagination controls will be visible on the chart.
                (note: if paginated is true, you'll have to supply a "name" property to each object in data for the search bar to work)
             difficulty: Object that contains information about the difficulty of the questions (see wsQuestionsDetailsView)
             helpText: Optional. Any descriptive text to explain the chart to the user.
             hideIndividualAnswers: If true, then the "View individual answers" link won't be visible,
             listerControls: Any lister or search parameters that need to be passed in. See the wsLister for those
             downloadUrl: url used by "View Individual Answers" modal to get all interactions for this card
        }
         */

        definition: "=",
        first: "=?",
        last: "=?"
      },
      link: function link(scope, element) {
        scope.pagingReady = false;
        scope.openAnswersModal = function (_questionId, _title) {
          $uibModal.open({
            controller: "AnswersModalCtrl",
            templateUrl: 'modules/app/views/answers-modal.html',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              questionId: function questionId() {
                return _questionId;
              },
              cardId: function cardId() {
                return scope.definition.cardId;
              },
              title: function title() {
                return _title;
              },
              downloadUrl: function downloadUrl() {
                return scope.definition.downloadUrl(_questionId);
              }
            }
          });
        };
        var defaults = {
          bullet: null,
          chart: null,
          customCharts: null,
          title: {
            text: null,
            emphasized: false
          },
          subtitle: null,
          subtitleData: null,
          currentDuration: "Month",
          updateChartData: null,
          durations: [],
          width: undefined,
          height: undefined,
          questionId: null,
          isQuestion: false,
          selectedDataOption: 0,
          dataOptions: null,
          paginated: false,
          showHowToRead: false,
          helpText: null,
          hideIndividualAnswers: false
        };
        scope.section = _.extend({}, defaults, scope.definition);
        if (scope.definition.cardId === 'preview') {
          scope.section.hideIndividualAnswers = true;
        }
        scope.difficultyThresholds = DifficultyThresholds;
        function fetchSearchSuggestions(params) {
          return Paginate.fetchData(params, scope.section.data);
        }
        function fetchData(params) {
          return Paginate.fetchData(params, scope.section.data).then(function (response) {
            scope.section.updateChartData(response.results, element);
            return response;
          });
        }
        if (scope.section.paginated) {
          scope.pagingReady = true;
          if (scope.definition.listerControls) {
            _.defaults(scope, scope.definition.listerControls);
          }
          Paginate.setupPaging(scope, fetchData, fetchSearchSuggestions);
        } else {
          scope.section.updateChartData();
        }
        scope.changeType = function changeType(resetPage) {
          if (scope.section.paginated && resetPage) {
            resetPage();
          } else {
            scope.section.updateChartData();
          }
        };
      }
    };
  }]).factory("wsTimelineChart", ["$q", function ($q) {
    return {
      createMulti: function createMulti(entries, entryIdField, timelineSource, config) {
        timelineSource = timelineSource || function () {
          var deferred = $q.defer();
          deferred.resolve();
          return deferred.promise;
        };
        return timelineSource(entries).then(function (response) {
          if (!response) {
            return;
          }
          var timelineResults = response.data.results[0].result;
          var allDates = _.reduce(timelineResults, function (memo, x) {
            var dates = _.map(x, function (i) {
              return moment.utc(i.date);
            });
            return memo.concat(dates);
          }, []);
          if (allDates.length > 0) {
            var maxInteractions = _.max(_.map(timelineResults, function (x) {
              return _.max(_.map(x, function (i) {
                return i.total;
              }));
            }));

            //Get the earliest & latest date in our dataset
            var earliestDate = _.min(allDates),
              latestDate = _.max(allDates);
            angular.forEach(entries, function (data) {
              var timeline = timelineResults[data[entryIdField]];
              data.timelineChartConfig = _.isEmpty(timeline) ? null : {
                type: "interaction-timeline",
                data: timeline,
                maxInteractions: maxInteractions,
                lastDate: latestDate.toDate(),
                firstDate: earliestDate.toDate(),
                colors: config ? config.colors : null
              };
            });
          }
          return response;
        });
      }
    };
  }]).factory("wsQuestionCharts", ["$filter", "numberFilter", "ChartBuilder", "screenSize", "wsColors", 'ChartUtils', function ($filter, numberFilter, ChartBuilder, screenSize, wsColors, ChartUtils) {
    var isPhone = screenSize.is('xs');
    function getColorByIndex(index, config) {
      // Reserve color[0] for correct responses.
      var colors = wsColors.getVizColors();
      if (colors.length > 0) {
        colors = colors.slice(1);
      }
      return ChartUtils.getSeriesColor(config, index + 1, colors[(index + 1) % colors.length]);
    }
    function getNumberWord(number) {
      var value = parseInt(number).toString();
      if (value.length > 1) {
        // Check for special case: 11 - 13 are all "th".
        // So if the second to last digit is 1, it is "th".
        var secondToLastDigit = value[value.length - 2];
        if (secondToLastDigit === '1') {
          return number + "th";
        }
      }
      var lastDigit = value[value.length - 1];
      switch (lastDigit) {
        case '1':
          return number + "st";
        case '2':
          return number + "nd";
        case '3':
          return number + "rd";
        default:
          return number + "th";
      }
    }
    function getResponseNames(responses) {
      // takes array of response (CmiData) objects
      return _.map(_(responses).pluck("description"), function (s) {
        return _.isUndefined(s) ? 'undefined' : _.unescape(s.replace('_', ' '));
      });
    }
    function formatLabel(text, len) {
      // Format multi-value responses (with [,] delimiters)
      if (text.indexOf('[,]') > -1) {
        var vals = text.split('[,]');
        text = '';
        for (var i = 0; i < vals.length; i++) {
          text += '"' + vals[i] + '"';
          if (i + 1 < vals.length) {
            text += ",";
          }
        }
      }
      return $filter('truncate')(text, len);
    }
    function responseCount(count) {
      return numberFilter(count, 0) + (count === 1 ? " response" : " responses");
    }
    function formatChartTooltip(color, percent, verb, label, count, rank) {
      return "\n                        <div class=\"watershed-tooltip\">\n                            <span class=\"swatch\" style=\"color: ".concat(color, " !important;\">\u2587 </span>\n                            ").concat(Math.round(percent), "% ").concat(verb, " <strong>").concat(label, "</strong> ").concat(rank ? rank : '', "<br>\n                            <span class=\"swatch\">\u2587 </span>( ").concat(responseCount(count), " )\n                        </div>\n                    ");
    }
    function getLikertColors(numSteps, config) {
      var redDark = ChartUtils.getSeriesColor(config, 0, wsColors.wsRedDark),
        red = ChartUtils.getSeriesColor(config, 1, wsColors.wsRed),
        redMedium = ChartUtils.getSeriesColor(config, 2, wsColors.wsRedMedium),
        redLight = ChartUtils.getSeriesColor(config, 3, wsColors.wsLightRed),
        neutral = ChartUtils.getSeriesColor(config, 4, wsColors.wsGrayLightest),
        greenLight = ChartUtils.getSeriesColor(config, 5, wsColors.wsLightGreen),
        greenMedium = ChartUtils.getSeriesColor(config, 6, wsColors.wsGreenMedium),
        green = ChartUtils.getSeriesColor(config, 7, wsColors.wsGreen),
        greenDark = ChartUtils.getSeriesColor(config, 8, wsColors.wsGreenDark);
      switch (numSteps) {
        case 2:
          return [red, green];
        case 3:
          return [red, neutral, green];
        case 4:
          return [red, redLight, greenLight, green];
        case 5:
          return [red, redLight, neutral, greenLight, green];
        case 6:
          return [red, redMedium, redLight, greenLight, greenMedium, green];
        case 7:
          return [red, redMedium, redLight, neutral, greenLight, greenMedium, green];
        case 8:
          return [redDark, red, redMedium, redLight, greenLight, greenMedium, green, greenDark];
        default:
          return [redDark, red, redMedium, redLight, neutral, greenLight, greenMedium, green, greenDark];
      }
    }
    function isCorrect(response) {
      // takes a response (CmiData) object
      return response.successCount > 0;
    }
    function choseVerb(isCorrect, isSurveyMode) {
      if (isSurveyMode) {
        return 'of responses answered';
      } else {
        return isCorrect ? 'of responses were correct with answer' : 'of responses were incorrect with answer';
      }
    }
    return {
      "choice": function choice(section, data, isSurveyMode, config) {
        var responseNames = getResponseNames(data.responses);
        section.chart = new ChartBuilder().type("bar").xAxis().categories(responseNames).labels().useHTML(true).formatter(function () {
          var label = formatLabel(this.value, 24);
          var response = data.responses[_.indexOf(responseNames, this.value)];
          return isCorrect(response) && !isSurveyMode ? '<strong>' + label + '</strong>' : label;
        }).style({
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          width: '150px'
        }).overflow('justify').build().build().yAxis().min(0).max(100).opposite(true).title().text(null).build().labels().overflow('justify').formatter(function () {
          return this.isFirst ? this.value + "%" : this.value;
        }).build().build().series().name("Percent").data(data.responses, function (response, index) {
          var correct = isCorrect(response);
          return {
            name: responseNames[index],
            value: response.count,
            y: response.count / data.totalCount * 100.0,
            isCorrect: correct,
            color: function () {
              if (isSurveyMode) {
                return getColorByIndex(index, config);
              }
              return correct ? ChartUtils.getSeriesColor(config, 0, wsColors.wsGreen) : wsColors.colorVizGrayLight;
            }()
          };
        }).build().legend().enabled(false).build().title().text(null).build().tooltip().followPointer(true).backgroundColor('transparent').borderWidth(0).shadow(false).formatter(function () {
          var verb = choseVerb(this.point.isCorrect, isSurveyMode);
          return formatChartTooltip(this.point.color, this.y, verb, this.point.name, this.point.value);
        }).useHTML(true).build().result();
        section.chart.chart.height = responseNames.length * 22 + 45;
        section.height = responseNames.length * 22 + 40;
      },
      "true-false": function trueFalse() {
        return this.choice.apply(this, arguments);
      },
      "activity": function activity() {
        return this.choice.apply(this, arguments);
      },
      "other": function other() {
        return this.choice.apply(this, arguments);
      },
      "pie-chart": function pieChart(section, data, isSurveyMode, isNumericRange, config) {
        // color the pie-chart sections
        var colorIndex = 0;
        _.each(data.responses, function (response) {
          response.color = isCorrect(response) && !isSurveyMode ? ChartUtils.getSeriesColor(config, 0, wsColors.wsGreen) : isNumericRange && !isSurveyMode ? wsColors.colorVizGrayLight : getColorByIndex(colorIndex++, config);
        });
        var responseNames = getResponseNames(data.responses);
        section.chart = new ChartBuilder().type("pie").plotOptions({
          pie: {
            dataLabels: {
              distance: 15
            }
          }
        }).series().name("Percentage").data(data.responses, function (response, index) {
          var correct = isCorrect(response);
          return {
            name: responseNames[index],
            value: response.count,
            isCorrect: correct,
            y: response.count / data.totalCount * 100.0,
            dataLabels: {
              formatter: function formatter() {
                return formatLabel(this.point.name, 24) + ': ' + Math.round(this.percentage) + '%';
              },
              style: correct && !isSurveyMode ? {
                fontWeight: "bold",
                color: ChartUtils.getSeriesColor(config, 0, wsColors.wsGreen)
              } : {}
            },
            color: correct ? wsColors.wsGreen : response.color
          };
        }).build().legend().enabled(false).build().title().text(null).build().tooltip().backgroundColor('transparent').borderWidth(0).shadow(false).formatter(function () {
          var verb = choseVerb(this.point.isCorrect, isSurveyMode);
          return formatChartTooltip(this.point.color, this.y, verb, this.point.name, this.point.value);
        }).useHTML(true).build().result();
        section.chart.chart.height = 300;
      },
      "fill-in": function fillIn(section, data, isSurveyMode, config) {
        // preSort responses into groups by numerical value (if any)
        var groups = _.groupBy(data.responses, function (r) {
          // if response contains a number, group by extracted numerical value
          // matches optional +/-, integer, float, or exponent form of number delimited by word boundary
          var re = /\b[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?\b/;
          var matches = re.exec(r.description);
          return matches ? parseFloat(matches[0]) : NaN;
        });
        // flatten the groups, sorting as we go
        var preSort = _.reduce(groups, function (memo, group) {
          return memo.concat(_.sortBy(group, function (response) {
            // sort case-insensitive, with surrounding whitespace trimmed
            return response.description.toLowerCase().trim();
          }));
        }, []);
        // group the sorted array by correct/incorrect answers & flatten
        groups = _.groupBy(preSort, function (r) {
          return isCorrect(r) ? 0 : 1;
        });
        data.responses = _.flatten(_.values(groups));
        return this["pie-chart"].apply(this, [section, data, isSurveyMode, false, config]);
      },
      "long-fill-in": function longFillIn() {
        return this["fill-in"].apply(this, arguments);
      },
      "numeric": function numeric(section, data, isSurveyMode, config) {
        // sort responses numerically
        data.responses = _.sortBy(data.responses, function (r) {
          return parseFloat(r.description);
        });
        var isNumericRange = data.correctResponses.length > 0 && data.correctResponses[0].indexOf('[:]') !== -1;
        return this["pie-chart"].apply(this, [section, data, isSurveyMode, isNumericRange, config]);
      },
      "likert": function likert(section, data, isSurveyMode, config) {
        var responseNames = getResponseNames(data.responses);
        var responseIndexById = _.object(_.map(data.responses, function (response, index) {
          return [response.id, index];
        }));
        var colors = getLikertColors(responseNames.length, config);
        section.chart = new ChartBuilder().type("bar").plotOptions({
          series: {
            stacking: 'percent'
          }
        }).xAxis().lineWidth(0).gridLineWidth(0).minorGridLineWidth(0).minorTickColor(0).tickLength(0).title().text(null).build().labels().enabled(false).build().build().yAxis().lineWidth(0).gridLineWidth(0).minorGridLineWidth(0).minorTickColor(0).tickLength(0).title().text(null).build().labels().enabled(false).build().reversed(true).build().series(data.responses, function (builder, response) {
          var index = responseIndexById[response.id];
          return builder.name(responseNames[index]).color(colors[index]).data([{
            value: response.count,
            y: response.count / data.totalCount * 100.0
          }]);
        }).legend().symbolHeight(20).symbolWidth(20).labelFormatter(function () {
          return formatLabel(this.name, 30);
        }).layout(isPhone ? "vertical" : "horizontal").reversed(false).build().title().text(null).build().tooltip().followPointer(true).backgroundColor('transparent').borderWidth(0).shadow(false).formatter(function () {
          return formatChartTooltip(this.series.color, this.y, "chose", this.series.name, this.point.value);
        }).useHTML(true).build().result();
        section.chart.chart.height = 150;
      },
      "matching": function matching(section, data, isSurveyMode) {
        var sourceNames = getResponseNames(data.responses);
        section.customCharts = _.map(data.responses, function (response, sourceIndex) {
          var targetNames = getResponseNames(response.targets);
          return {
            type: "matching",
            data: {
              match: sourceNames[sourceIndex],
              targets: _.map(response.targets, function (target, targetIndex) {
                return {
                  name: targetNames[targetIndex],
                  answers: target.count,
                  answerPercent: Math.round(target.count * 100.0 / data.totalCount),
                  match: isCorrect(target) && !isSurveyMode
                };
              })
            },
            surveyMode: isSurveyMode
          };
        });
      },
      "sequencing": function sequencing(section, data, isSurveyMode, config) {
        // orders the heatmap to match first correctResponsePattern.
        // assumes that each row of responses table contains all choices (order can be different)
        var correctResponseIds = _.first(data.correctResponses).split("[,]");
        var sortedResponses = _.map(correctResponseIds, function (id) {
          return _.findWhere(_.first(data.responses), {
            id: id
          });
        });
        var responseNames = getResponseNames(sortedResponses);
        section.chart = new ChartBuilder().type("heatmap").xAxis().lineWidth(0).gridLineWidth(0).minorGridLineWidth(0).minorTickColor(0).tickLength(0).categories(_.range(1, responseNames.length + 1)).opposite(true).build().yAxis().lineWidth(0).gridLineWidth(0).minorGridLineWidth(0).minorTickColor(0).tickLength(0).categories(responseNames).reversed(true).title().text(null).build().build().series().name("Choices").data(data.responses, function (choiceResponses, choiceIndex) {
          return _.map(choiceResponses, function (response) {
            var correct = isCorrect(response);
            return {
              x: choiceIndex,
              y: _.indexOf(_.pluck(sortedResponses, 'id'), response.id),
              // fixes out of order responses
              value: response.count / data.totalCount * 100.0,
              count: response.count,
              isCorrect: correct,
              dataLabels: {
                enabled: true,
                style: {
                  textShadow: 'none',
                  fontWeight: correct && !isSurveyMode ? 'bold' : 'normal',
                  fontSize: '12px',
                  textOutline: 'none',
                  HcTextStroke: null
                },
                formatter: function formatter() {
                  return numberFilter(this.point.count, 0) || "";
                }
              }
            };
          });
        }, _.flatten).borderWidth(2).borderColor(wsColors.colorBorder).build().colorAxis({
          min: 0,
          minColor: wsColors.colorBorder,
          maxColor: ChartUtils.getSeriesColor(config, 0, wsColors.colorVizBlueLight)
        }).legend().enabled(false).build().title().text(null).build().tooltip().followPointer(true).backgroundColor('transparent').borderWidth(0).shadow(false).formatter(function () {
          var label = this.series.yAxis.categories[this.point.y],
            verb = isSurveyMode ? 'sequenced' : this.point.isCorrect ? 'correctly sequenced' : 'incorrectly sequenced',
            rank = getNumberWord(this.series.xAxis.categories[this.point.x]);
          return formatChartTooltip(this.point.color, this.point.value, verb, label, this.point.count, rank);
        }).useHTML(true).build().result();
      }
    };
  }]);
})();
